// extracted by mini-css-extract-plugin
module.exports = {"outer":"outer___3XVlY","left":"left___Dm80t","right":"right___OdhYb"};